module.exports = __webpack_public_path__ + "static/media/loader.f158ede5.gif";